// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__2HA_t index_box__1791B index_marginBottom__1X5HP"};